import { Icon } from '../components/Icon';
import { getMode } from '../engine/registry';
import { useStats } from '../state/StatsContext';
import { fromNow } from '../utils/date';
import { commas } from '../utils/format';

export function HistoryScreen() {
  const { stats } = useStats();
  const history = stats.history;

  return (
    <div>
      <div className="cv-page-head">
        <span className="cv-eyebrow">Log</span>
        <h1>History</h1>
      </div>

      {history.length === 0 ? (
        <div className="cv-empty">
          <Icon name="history" size={40} />
          <p>No puzzles yet — play one and it’ll show up here.</p>
        </div>
      ) : (
        <div className="cv-history">
          {history.map((h) => {
            const mode = getMode(h.modeId);
            return (
              <div className="cv-history__row" key={h.id}>
                <span
                  className="cv-mode-card__glyph"
                  style={{ width: '2.4rem', height: '2.4rem' }}
                  title={mode?.name}
                >
                  {mode ? <Icon name={mode.glyph} size={18} /> : null}
                </span>
                <div>
                  <div className="cv-row" style={{ gap: 'var(--space-2xs)' }}>
                    <strong>{mode?.name ?? h.modeId}</strong>
                    <span className="cv-faint" style={{ fontSize: 'var(--text-xs)' }}>
                      {h.playMode === 'daily'
                        ? `Daily${h.dayNumber ? ` #${h.dayNumber}` : ''}${h.archive ? ' · archive' : ''}`
                        : 'Endless'}
                      {h.hintsUsed ? ` · ${h.hintsUsed} hint${h.hintsUsed === 1 ? '' : 's'}` : ''}
                    </span>
                  </div>
                  <div className="cv-history__when">
                    {fromNow(h.completedAt)} · {h.status === 'won' ? 'Solved' : 'Missed'}
                    {h.answer && h.status === 'won' ? ` · ${h.answer}` : ''}
                  </div>
                </div>
                <span
                  className="cv-history__score"
                  style={{ color: h.status === 'won' ? 'var(--ink)' : 'var(--ink-faint)' }}
                >
                  {h.status === 'won' ? commas(h.score) : '—'}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
